import { Button, Typography } from '@ace-clublabs/shared-component-library';

export const ExploreBenefitButton = () => {
  return (
    <Button
      className="explore-benefit-button"
      size="medium"
      label={
        <Typography sx={{ fontSize: '1rem !important', fontWeight: '500', lineHeight: '1.5rem', color: '#0C72DF' }}>
          Explore & compare full benefits
        </Typography>
      }
      variant="outlined"
      onClick={() => {
        window.open('https://www.ace.aaa.com/membership/benefit-chart.html', '_blank');
      }}
      sx={{ width: '17rem', marginTop: '1.5rem', alignSelf: 'center' }}
    />
  );
};
